// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { BaseModel, DealerModel, PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export interface AllLocationsModel extends BaseModel {
    dealers?: DealerModel[];
    defaultLatitude?: number;
    defaultLongitude?: number;
    defaultRadius?: number;
    startDealerNumber?: number;
    distanceUnitOfMeasure?: string;
    formattedAddress?: string;
    pagination: PaginationModel | null;
}

export type xAllLocationsStateType = Readonly<{
    isLoading?: boolean;
    failedMessage?: string;
    allLocations?: AllLocationsModel;
}>;

export const initialAllLocationsState: xAllLocationsStateType = {
    isLoading: false,
    allLocations: undefined,
    failedMessage: "",
};

const reducer = {
    "xAllLocations/BeginLoadAllLocations": (draft: Draft<xAllLocationsStateType>, action: {}) => {
        draft.isLoading = true;
        draft.failedMessage = "";
    },
    "xAllLocations/CompleteLoadAllLocations": (
        draft: Draft<xAllLocationsStateType>,
        action: { allLocations: AllLocationsModel },
    ) => {
        draft.isLoading = false;
        draft.failedMessage = "";

        draft.allLocations = {
            ...action.allLocations,
        };
    },
    "xAllLocations/FailedLoadAllLocations": (
        draft: Draft<xAllLocationsStateType>,
        action: { failedMessage: string },
    ) => {
        draft.isLoading = false;
        draft.failedMessage = action.failedMessage;
    },
};

const xAllLocations = createTypedReducerWithImmer(initialAllLocationsState, reducer);

(reducers as any).xAllLocations = xAllLocations;

export type xAllLocationsState = {
    xAllLocations: xAllLocationsStateType;
} & ApplicationState;

type xAllLocationsReducers = {
    [key: string]: typeof xAllLocations;
};

export type xAllLocationsActions = Parameters<xAllLocationsReducers[keyof xAllLocationsReducers]>[1] | AnyAction;
